import useSWR from 'swr';
import { apiFetch } from './api';
import { ActivityType } from './activityTypes';
import { DataSource } from './dataSources';

export interface ActivityDefinition {
  id: string;
  name: string;
  type: ActivityType;
  sources: DataSource[];
}

export const useActivityCatalog = () => {
  const { data, error, mutate } = useSWR<ActivityDefinition[]>(
    '/activities/catalog',
    async (url: string) => {
      const res = await apiFetch(url);
      return res.data?.data || res.data;
    }
  );
  return {
    catalog: data,
    isLoading: !error && !data,
    isError: error,
    refresh: mutate,
  };
};
